import { useState } from "react";
import { Link } from "react-router-dom";
import { Stethoscope, ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="h-10 w-10 rounded-2xl bg-emerald-500 flex items-center justify-center">
            <Stethoscope className="h-5 w-5 text-white" />
          </div>
          <span className="font-display font-extrabold text-slate-900 text-xl">ZAP DOUTOR</span>
        </div>
        {sent ? (
          <div className="bg-white border border-slate-200 rounded-xl p-6 text-center shadow-sm">
            <h2 className="font-display text-xl font-bold text-slate-900">Verifique seu e-mail</h2>
            <p className="text-sm text-slate-500 mt-2" data-testid="forgot-confirmation">
              Se este e-mail estiver cadastrado, enviaremos um link para redefinição da senha.
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 text-emerald-600 hover:underline text-sm font-medium mt-6">
              <ArrowLeft className="h-4 w-4" /> Voltar para o login
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold text-slate-900">Recuperar senha</h2>
            <p className="text-sm text-slate-500 mt-1 mb-6">Informe seu e-mail para receber o link de redefinição.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" data-testid="forgot-email-input" />
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <Button type="submit" disabled={loading} className="w-full bg-emerald-500 hover:bg-emerald-600 h-11" data-testid="forgot-submit-button">
                {loading ? "Enviando..." : "Enviar link"}
              </Button>
            </form>
            <Link to="/login" className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-700 text-sm mt-6">
              <ArrowLeft className="h-4 w-4" /> Voltar para o login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
